import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import device from './utils/device'

Vue.config.productionTip = false

Vue.use(ElementUI);

// 全局注入设备检测方法
Vue.prototype.$device = device

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
